import { Component, Inject, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { TranslatePipe } from '../../pipes/translate.pipe';

export interface ConfirmDialogData {
  title: string;
  message: string;
  withTimerConfirmation?: number;
  cancelText?: string;
  confirmText?: string;
}

@Component({
  selector: 'app-confirm-dialog',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    TranslatePipe
  ],
  template: `
    <h2 mat-dialog-title>{{ data.title }}</h2>
    <mat-dialog-content>{{ data.message }}</mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-stroked-button [mat-dialog-close]="false">{{ data.cancelText || 'general.buttons.cancel' | translate | async }}</button>
      <button mat-stroked-button color="warn" [mat-dialog-close]="true" [disabled]="progress > 0">
        {{ data.confirmText || 'general.buttons.confirm' | translate | async }}
        @if (progress > 0) {
          <span class="timer">({{ progress }})</span>
        }
      </button>
    </mat-dialog-actions>
  `,
  styles: [`
    h2 {
      margin: 0;
      font-size: 1.25rem;
    }
    .timer {
      font-weight: bold;
    }
  `]
})

export class ConfirmDialogComponent implements OnDestroy {
  timerConfirmation: any;
  progress: number = 0;
  constructor(
    public dialogRef: MatDialogRef<ConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmDialogData
  ) {
    if (this.data.withTimerConfirmation) {
      this.progress = this.data.withTimerConfirmation;
      this.timerConfirmation = setInterval(() => {
        this.progress -= 1;
        if (this.progress <= 0) {
          clearInterval(this.timerConfirmation);
        }
      }, 1000);
    }
  }

  ngOnDestroy(): void {
    if (this.timerConfirmation) {
      clearInterval(this.timerConfirmation);
    }
  }
}
